// UserLastPasswordChangeView.jsx
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import { getUserLastPasswordChangeRows } from "./checkRowsUserData";

const UserLastPasswordChangeView = ({ entityData }) => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    setRows(getUserLastPasswordChangeRows(entityData));
  }, [entityData]);

  return (
    rows.length > 0 && (
      <Box display={"flex"} flexDirection={"column"} gap={1}>
        <Box display={"flex"} gap={1} alignItems={"center"}>
          <Typography variant="subtitle2" fontWeight={"500"}>
            Last Changed
          </Typography>
        </Box>
        <Box display={"flex"} flexDirection={"column"} ml={3}>
          {rows.map((row) => (
            <TextIntegrationStyle
              key={row.id}
              title={
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  alignItems={"center"}
                  gap={1}
                >
                  <IntegrationImage
                    name={row.source}
                    width={"16px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={row.last_time_changed_password}
            ></TextIntegrationStyle>
          ))}
        </Box>
      </Box>
    )
  );
};

export default UserLastPasswordChangeView;
